// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"N3-z","dimensionLabel":"O3-z","styleChooserControlWrapper":"P3-z","styleChooserControl":"Q3-z","disabled":"R3-z","giftCard":"S3-z","styleChooserText":"T3-z"};